export const INSIGHTS_CLASSIC_PATH = "/dashboard/insights-v2";
export const INSIGHTS_PREVIEW_PATH = "/dashboard/insights-preview";
export const INSIGHTS_PREVIEW_ADS_PATH = `${INSIGHTS_PREVIEW_PATH}/ads`;

export function isPaidSocialInsightsPreviewPath(pathname: string): boolean {
  return (
    pathname === INSIGHTS_PREVIEW_ADS_PATH ||
    pathname.startsWith(`${INSIGHTS_PREVIEW_ADS_PATH}/`)
  );
}
